import { ConfigProps } from '@config/types'

const API_VERSION = 'latest'

const config = ({ apiUrl, imageUrl, baseUrl, deploymentEnv }: ConfigProps) => ({
  env: deploymentEnv,
  imageUrl,
  apiUrl,
  versionedApiUrl: `${apiUrl}/${API_VERSION}`,
  skeletonUrl: `${apiUrl}/${API_VERSION}/skeleton-web/`,
  skeletonUrl___romandie: `${apiUrl}/${API_VERSION}/fr/skeleton-web/`,
  rootUrl: '/',
  rootUrl___romandie: '/fr/',
  baseUrl,
})

export type configType = ReturnType<typeof config>
export default config
